const TITLE_SITE_SUFFIX_PATTERN = /\s*[|\-–]\s*Jungle( Blog)?\s*$/i;

/** The visible h1, without importing the article index or Markdown loaders into home-page code. */
export function getMarketingPageHeading(entry: { heading: string | null; title: string }): string {
  return entry.heading ?? entry.title.replace(TITLE_SITE_SUFFIX_PATTERN, "");
}
